module.exports = __webpack_public_path__ + "static/img/4.e199692.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/4.png
// module id = Dn8o
// module chunks = 0